var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTyping(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 447,
    height: 387,
    viewBox: "0 0 447 387",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.311 120.037C397.577 96.5841 403.011 74.3721 393.412 51.8051C375.787 10.3661 322.644 -11.6079 281.342 8.00907C260.225 18.0391 242.161 32.6321 218.901 38.0001C156.122 52.4871 59.2247 -24.7149 25.0467 65.1731C13.3227 96.0061 18.0237 136.648 39.2607 162.425C46.0747 170.696 54.3877 177.902 59.4267 187.359C73.2187 213.244 53.7007 241.699 44.8557 265.851C23.9557 322.92 102.763 354.498 145.53 360.319C216.27 369.947 274.589 288.996 344.901 322C393.901 345 436.901 289 427.901 233C422.008 196.336 392.195 161.251 394.98 123.894C395.076 122.598 395.188 121.313 395.311 120.037Z",
    fill: "#C6FF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M395.311 120.037C397.577 96.5841 403.011 74.3721 393.412 51.8051C375.787 10.3661 322.644 -11.6079 281.342 8.00907C260.225 18.0391 242.161 32.6321 218.901 38.0001C156.122 52.4871 59.2247 -24.7149 25.0467 65.1731C13.3227 96.0061 18.0237 136.648 39.2607 162.425C46.0747 170.696 54.3877 177.902 59.4267 187.359C73.2187 213.244 53.7007 241.699 44.8557 265.851C23.9557 322.92 102.763 354.498 145.53 360.319C216.27 369.947 274.589 288.996 344.901 322C393.901 345 436.901 289 427.901 233C422.008 196.336 392.195 161.251 394.98 123.894C395.076 122.598 395.188 121.313 395.311 120.037Z",
    fill: "#83B9FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6716 135.257C77.7414 135.257 93.2006 119.798 93.2006 100.728C93.2006 81.6584 77.7414 66.1992 58.6716 66.1992C39.6017 66.1992 24.1426 81.6584 24.1426 100.728C24.1426 119.798 39.6017 135.257 58.6716 135.257Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0974 131.826C75.1672 131.826 90.6264 116.366 90.6264 97.2966C90.6264 78.2267 75.1672 62.7676 56.0974 62.7676C37.0275 62.7676 21.5684 78.2267 21.5684 97.2966C21.5684 116.366 37.0275 131.826 56.0974 131.826Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0989 128.393C73.2733 128.393 87.1959 114.471 87.1959 97.2962C87.1959 80.1218 73.2733 66.1992 56.0989 66.1992C38.9246 66.1992 25.002 80.1218 25.002 97.2962C25.002 114.471 38.9246 128.393 56.0989 128.393Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.453 73.9204C52.453 73.9204 49.022 65.3424 43.017 59.3374C37.012 53.3324 12.563 49.4724 12.563 49.4724C12.563 49.4724 17.71 54.1904 23.286 61.9114C28.862 69.6324 47.306 87.2184 47.306 87.2184C47.306 87.2184 38.299 79.4974 30.149 78.6394C21.999 77.7814 1.41101 82.0704 0.124011 82.0704C-1.16299 82.0704 7.84501 85.5014 14.279 88.5044C20.713 91.5074 45.591 94.0804 45.591 94.0804C45.591 94.0804 34.868 97.0834 27.576 99.6564C20.284 102.23 13.421 121.102 13.421 121.102C13.421 121.102 22.857 112.524 31.007 110.379C39.157 108.234 50.738 104.374 50.738 104.374C50.738 104.374 43.446 112.524 41.731 118.1C40.015 123.676 41.302 136.544 41.302 136.544C41.302 136.544 45.162 124.534 49.88 119.816C54.598 115.098 59.745 106.948 59.745 106.948C59.745 106.948 62.748 111.666 66.179 118.958C69.61 126.25 71.755 136.973 71.755 136.973C71.755 136.973 77.331 124.963 76.902 118.958C76.473 112.953 70.039 102.23 70.039 102.23C70.039 102.23 74.328 99.2274 80.762 101.801C87.196 104.375 98.348 115.098 98.348 115.098C98.348 115.098 95.774 100.943 91.485 95.3674C87.196 89.7914 68.752 88.0754 68.752 88.0754C68.752 88.0754 79.046 82.0704 85.48 80.7834C91.914 79.4964 100.493 82.4994 100.493 82.4994C100.493 82.4994 90.628 68.7734 82.907 67.9164C75.186 67.0584 63.605 79.0684 63.605 79.0684C63.605 79.0684 66.179 66.2004 67.036 61.9114C67.894 57.6224 66.178 46.8994 66.178 46.8994C66.178 46.8994 61.46 49.4734 55.884 57.6224C50.308 65.7704 52.453 73.9204 52.453 73.9204Z",
    fill: "#C6FF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.453 73.9204C52.453 73.9204 49.022 65.3424 43.017 59.3374C37.012 53.3324 12.563 49.4724 12.563 49.4724C12.563 49.4724 17.71 54.1904 23.286 61.9114C28.862 69.6324 47.306 87.2184 47.306 87.2184C47.306 87.2184 38.299 79.4974 30.149 78.6394C21.999 77.7814 1.41101 82.0704 0.124011 82.0704C-1.16299 82.0704 7.84501 85.5014 14.279 88.5044C20.713 91.5074 45.591 94.0804 45.591 94.0804C45.591 94.0804 34.868 97.0834 27.576 99.6564C20.284 102.23 13.421 121.102 13.421 121.102C13.421 121.102 22.857 112.524 31.007 110.379C39.157 108.234 50.738 104.374 50.738 104.374C50.738 104.374 43.446 112.524 41.731 118.1C40.015 123.676 41.302 136.544 41.302 136.544C41.302 136.544 45.162 124.534 49.88 119.816C54.598 115.098 59.745 106.948 59.745 106.948C59.745 106.948 62.748 111.666 66.179 118.958C69.61 126.25 71.755 136.973 71.755 136.973C71.755 136.973 77.331 124.963 76.902 118.958C76.473 112.953 70.039 102.23 70.039 102.23C70.039 102.23 74.328 99.2274 80.762 101.801C87.196 104.375 98.348 115.098 98.348 115.098C98.348 115.098 95.774 100.943 91.485 95.3674C87.196 89.7914 68.752 88.0754 68.752 88.0754C68.752 88.0754 79.046 82.0704 85.48 80.7834C91.914 79.4964 100.493 82.4994 100.493 82.4994C100.493 82.4994 90.628 68.7734 82.907 67.9164C75.186 67.0584 63.605 79.0684 63.605 79.0684C63.605 79.0684 66.179 66.2004 67.036 61.9114C67.894 57.6224 66.178 46.8994 66.178 46.8994C66.178 46.8994 61.46 49.4734 55.884 57.6224C50.308 65.7704 52.453 73.9204 52.453 73.9204Z",
    fill: "#009A2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9023 60.8644C61.2003 59.6314 61.5283 58.4044 61.8883 57.1924",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2539 60.8613C36.2719 63.7933 41.2929 67.8263 43.8739 71.3463C48.5919 77.7803 58.0289 91.5063 58.0289 91.5063C58.0289 91.5063 57.3959 77.9033 60.2059 64.0093",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2871 56.7637C26.2871 56.7637 27.5421 57.5587 29.4111 58.8467",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0293 91.5065C58.0293 91.5065 74.3283 75.2075 81.1913 73.9205C88.0543 72.6335 94.0593 77.7805 94.0593 77.7805",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8953 105.138C24.9293 107.666 24.5723 109.093 24.5723 109.093",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6292 106.518C93.6292 106.518 91.0553 100.084 82.0483 97.0824C73.0413 94.0794 58.8862 93.6514 58.8862 93.6514C58.8862 93.6514 39.0382 100.147 31.7812 103.539",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2246 91.2012C55.0166 92.5952 58.8866 93.6502 58.8866 93.6502",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0078 83.5811C24.6708 83.8631 30.6678 84.4981 34.0088 85.9301C36.7308 87.0961 42.0948 88.7911 47.1478 90.2961",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4199 83.3564C13.4199 83.3564 14.9859 83.3564 17.3039 83.4474",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0287 96.2246C58.0287 96.2246 46.0187 114.24 45.1607 118.529C44.3027 122.818 44.3027 126.25 44.3027 126.25",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3672 101.892C65.6802 104.877 68.4542 108.859 69.6092 112.095C71.7542 118.1 72.6112 124.105 72.6112 124.105",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7441 97.5117C59.7441 97.5117 60.6961 98.5697 62.0251 100.203",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0033 77.6162C47.0033 77.6162 44.7873 68.6462 46.1623 60.2662C47.5373 51.8862 65.1453 34.4902 65.1453 34.4902C65.1453 34.4902 63.7163 41.3252 63.6903 50.8482C63.6643 60.3722 58.9403 85.4142 58.9403 85.4142C58.9403 85.4142 61.7533 73.8892 67.8733 68.4392C73.9923 62.9892 93.2183 54.4642 94.2633 53.7142C95.3083 52.9632 89.9933 61.0042 86.5183 67.1962C83.0433 73.3882 64.3373 89.9892 64.3373 89.9892C64.3373 89.9892 74.7983 86.1732 82.2223 84.0112C89.6463 81.8482 106.228 93.1752 106.228 93.1752C106.228 93.1752 93.5593 91.7112 85.6893 94.7222C77.8183 97.7332 66.1603 101.353 66.1603 101.353C66.1603 101.353 76.8363 103.72 81.4823 107.248C86.1283 110.777 92.5883 121.979 92.5883 121.979C92.5883 121.979 82.4473 114.475 75.8633 113.395C69.2783 112.315 60.3443 108.697 60.3443 108.697C60.3443 108.697 60.6573 114.281 62.1233 122.205C63.5893 130.129 68.1013 140.09 68.1013 140.09C68.1013 140.09 56.5673 133.587 53.4133 128.459C50.2593 123.331 49.2313 110.868 49.2313 110.868C49.2313 110.868 43.9963 110.931 40.2713 116.774C36.5463 122.617 33.7423 137.832 33.7423 137.832C33.7423 137.832 27.5763 124.833 27.8083 117.802C28.0403 110.771 42.0213 98.6192 42.0213 98.6192C42.0213 98.6192 30.1573 99.7462 24.1803 102.453C18.2033 105.16 12.9863 112.603 12.9863 112.603C12.9863 112.603 12.9943 95.7002 18.7653 90.5002C24.5363 85.3002 40.9483 88.3002 40.9483 88.3002C40.9483 88.3002 31.3523 79.3492 28.1533 76.3652C24.9543 73.3812 20.0943 63.6702 20.0943 63.6702C20.0943 63.6702 25.4273 63.0092 34.7103 66.3762C43.9913 69.7452 47.0033 77.6162 47.0033 77.6162Z",
    fill: "#009A2E"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.525 71.9392C31.564 71.1122 30.582 70.3062 29.582 69.5312",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7938 55.2275C54.2398 59.9525 52.5138 66.1575 52.4708 70.5225C52.3908 78.5005 52.7318 95.1535 52.7318 95.1535C52.7318 95.1535 45.3118 83.7355 34.9258 74.0885",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2497 48.418C58.2497 48.418 57.6937 49.795 56.9277 51.932",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.732 95.1533C52.732 95.1533 29.986 91.4203 23.66 94.3783C17.335 97.3363 15.459 105.019 15.459 105.019",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3457 89.2325C89.0417 88.9725 90.1637 89.9235 90.1637 89.9235",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5703 128.112C32.5703 128.112 30.9083 121.385 36.4733 113.692C42.0383 105.999 53.2863 97.3952 53.2863 97.3952C53.2863 97.3952 73.1973 91.0952 81.0703 89.6172",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8922 90.3535C55.8122 94.2815 53.2852 97.3955 53.2852 97.3955",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9923 66.5391C75.3693 69.4881 70.8683 73.5021 68.9893 76.6131C67.4593 79.1481 64.0903 83.6541 60.8633 87.8231",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2114 62.5146C84.2114 62.5146 82.9394 63.4286 81.1094 64.8536",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4824 98.9854C55.4824 98.9854 75.7454 106.613 78.9444 109.597C82.1434 112.581 84.1444 115.368 84.1444 115.368",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4526 106.703C54.3146 110.477 54.3846 115.33 55.3326 118.631C57.0926 124.76 59.8986 130.138 59.8986 130.138",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8396 101.031C54.8396 101.031 54.6836 102.446 54.5566 104.548",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M339.398 292.765H114.731C108.288 292.765 103.064 287.542 103.064 281.098V134.098C103.064 128.207 107.84 123.431 113.731 123.431H340.398C346.289 123.431 351.065 128.207 351.065 134.098V281.098C351.065 287.542 345.841 292.765 339.398 292.765Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M196.691 140.099H182.729V149.27H196.691V140.099Z",
    fill: "#263238"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M151.464 196.666H138.502V209.526H151.464V196.666Z",
    fill: "#263238"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M208.721 151.474H195.66V164.334H208.721V151.474Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.524 140.099H166.562V149.27H180.524V140.099Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M223.987 151.474H210.926V164.334H223.987V151.474Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M212.857 140.099H198.895V149.27H212.857V140.099Z",
    fill: "#263238"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M143.63 181.602H119.066V194.462H143.63V181.602Z",
    fill: "#263238"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M178.19 151.474H165.129V164.334H178.19V151.474Z",
    fill: "#263238"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M136.297 196.666H119.066V209.526H136.297V196.666Z",
    fill: "#263238"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M229.023 140.099H215.061V149.27H229.023V140.099Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M147.659 151.474H134.598V164.334H147.659V151.474Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.191 140.099H134.229V149.27H148.191V140.099Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M164.358 140.099H150.396V149.27H164.358V140.099Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.924 151.474H149.863V164.334H162.924V151.474Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M193.456 151.474H180.395V164.334H193.456V151.474Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M293.689 140.099H279.727V149.27H293.689V140.099Z",
    fill: "#263238"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M309.855 140.099H295.893V149.27H309.855V140.099Z",
    fill: "#263238"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M300.315 151.474H287.254V164.334H300.315V151.474Z",
    fill: "#263238"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M315.581 151.474H302.52V164.334H315.581V151.474Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M339.733 196.666H320.502V209.526H339.733V196.666Z",
    fill: "#263238"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M326.021 140.099H312.059V149.27H326.021V140.099Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M132.393 151.474H119.066V164.334H132.393V151.474Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M245.191 140.099H231.229V149.27H245.191V140.099Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M261.357 140.099H247.395V149.27H261.357V140.099Z",
    fill: "#263238"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M254.518 151.474H241.457V164.334H254.518V151.474Z",
    fill: "#263238"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M285.049 151.474H271.988V164.334H285.049V151.474Z",
    fill: "#263238"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M239.252 151.474H226.191V164.334H239.252V151.474Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M269.784 151.474H256.723V164.334H269.784V151.474Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M277.523 140.099H263.561V149.27H277.523V140.099Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M257.63 196.666H244.668V209.526H257.63V196.666Z",
    fill: "#263238"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M325.63 181.602H312.668V194.462H325.63V181.602Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M310.464 181.602H297.502V194.462H310.464V181.602Z",
    fill: "#263238"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M318.298 196.666H305.336V209.526H318.298V196.666Z",
    fill: "#263238"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M303.13 196.666H290.168V209.526H303.13V196.666Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M272.798 196.666H259.836V209.526H272.798V196.666Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M287.964 196.666H275.002V209.526H287.964V196.666Z",
    fill: "#263238"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M295.298 181.602H282.336V194.462H295.298V181.602Z",
    fill: "#263238"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M280.13 181.602H267.168V194.462H280.13V181.602Z",
    fill: "#263238"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M339.734 140.099H328.227V149.27H339.734V140.099Z",
    fill: "#263238"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M132.025 140.099H119.066V149.27H132.025V140.099Z",
    fill: "#263238"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M339.733 211.729H119.066V225.097H339.733V211.729Z",
    fill: "#263238"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M339.733 151.474H317.785V164.334H339.733V151.474Z",
    fill: "#263238"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M339.734 181.602H327.836V194.462H339.734V181.602Z",
    fill: "#263238"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M324.168 179.303H321.963V166.538H309.001V179.303H306.797V166.538H293.835V179.303H291.63V166.538H278.668V179.303H276.464V166.538H263.501V179.303H261.297V166.538H248.335V179.303H246.13V166.538H233.168V179.303H230.964V166.538H218.001V179.303H215.797V166.538H202.835V179.303H200.63V166.538H187.668V179.303H185.463V166.538H172.501V179.303H170.297V166.538H157.335V179.303H155.13V166.538H142.168V179.303H139.963V166.538H119.066V179.397H339.732V166.538H324.168V179.303Z",
    fill: "#263238"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M219.464 181.602H206.502V194.462H219.464V181.602Z",
    fill: "#263238"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M264.964 181.602H252.002V194.462H264.964V181.602Z",
    fill: "#263238"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M189.13 181.602H176.168V194.462H189.13V181.602Z",
    fill: "#263238"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M196.964 196.666H184.002V209.526H196.964V196.666Z",
    fill: "#263238"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M204.298 181.602H191.336V194.462H204.298V181.602Z",
    fill: "#263238"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M173.964 181.602H161.002V194.462H173.964V181.602Z",
    fill: "#263238"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M166.63 196.666H153.668V209.526H166.63V196.666Z",
    fill: "#263238"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M181.798 196.666H168.836V209.526H181.798V196.666Z",
    fill: "#263238"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M234.63 181.602H221.668V194.462H234.63V181.602Z",
    fill: "#263238"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M242.464 196.666H229.502V209.526H242.464V196.666Z",
    fill: "#263238"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M249.798 181.602H236.836V194.462H249.798V181.602Z",
    fill: "#263238"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M212.13 196.666H199.168V209.526H212.13V196.666Z",
    fill: "#263238"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M227.298 196.666H214.336V209.526H227.298V196.666Z",
    fill: "#263238"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M158.798 181.602H145.836V194.462H158.798V181.602Z",
    fill: "#263238"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M365.229 31.4316H87.5687C81.7327 31.4316 77.4867 36.9686 78.9997 42.6056L99.3007 118.195C100.342 122.071 103.856 124.766 107.87 124.766H136.206V129.97H317.926V124.766H344.929C348.943 124.766 352.457 122.071 353.498 118.195L373.799 42.6056C375.312 36.9686 371.065 31.4316 365.229 31.4316Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M333.827 118.099H118.969L97.4844 40.7646H355.312L333.827 118.099Z",
    fill: "#009A2E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M133.231 84.1602V85.1592H129.436V84.1602H133.231Z",
    fill: "#003F8C"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M137.947 84.1602V85.1592H134.152V84.1602H137.947Z",
    fill: "#003F8C"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M142.665 84.1602V85.1592H138.869V84.1602H142.665Z",
    fill: "#003F8C"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M147.382 84.1602V85.1592H143.586V84.1602H147.382Z",
    fill: "#003F8C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M152.098 84.1602V85.1592H148.303V84.1602H152.098Z",
    fill: "#003F8C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M156.816 84.1602V85.1592H153.021V84.1602H156.816Z",
    fill: "#003F8C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M161.533 84.1602V85.1592H157.738V84.1602H161.533Z",
    fill: "#003F8C"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M166.204 89.43L162.025 78.29H163.07L167.249 89.43H166.204Z",
    fill: "#003F8C"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M129.414 67.9375V68.9355H125.619V67.9375H129.414Z",
    fill: "#003F8C"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M134.131 67.9375V68.9355H130.336V67.9375H134.131Z",
    fill: "#003F8C"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M138.848 67.9375V68.9355H135.053V67.9375H138.848Z",
    fill: "#003F8C"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M143.566 67.9375V68.9355H139.77V67.9375H143.566Z",
    fill: "#003F8C"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M148.281 67.9375V68.9355H144.486V67.9375H148.281Z",
    fill: "#003F8C"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M156.256 67.9375V68.9355H152.461V67.9375H156.256Z",
    fill: "#003F8C"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M160.975 67.9375V68.9355H157.18V67.9375H160.975Z",
    fill: "#003F8C"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M165.69 67.9375V68.9355H161.895V67.9375H165.69Z",
    fill: "#003F8C"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M170.408 67.9375V68.9355H166.613V67.9375H170.408Z",
    fill: "#003F8C"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M175.125 67.9375V68.9355H171.33V67.9375H175.125Z",
    fill: "#003F8C"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M179.842 67.9375V68.9355H176.047V67.9375H179.842Z",
    fill: "#003F8C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M184.559 67.9375V68.9355H180.764V67.9375H184.559Z",
    fill: "#003F8C"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M192.533 67.9375V68.9355H188.738V67.9375H192.533Z",
    fill: "#003F8C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M197.25 67.9375V68.9355H193.455V67.9375H197.25Z",
    fill: "#003F8C"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M201.967 67.9375V68.9355H198.172V67.9375H201.967Z",
    fill: "#003F8C"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M209.94 67.9375V68.9355H206.145V67.9375H209.94Z",
    fill: "#003F8C"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M214.658 67.9375V68.9355H210.863V67.9375H214.658Z",
    fill: "#003F8C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M219.375 67.9375V68.9355H215.58V67.9375H219.375Z",
    fill: "#003F8C"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M237.121 67.9375V68.9355H233.326V67.9375H237.121Z",
    fill: "#003F8C"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M241.838 67.9375V68.9355H238.043V67.9375H241.838Z",
    fill: "#003F8C"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M246.555 67.9375V68.9355H242.76V67.9375H246.555Z",
    fill: "#003F8C"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M251.272 67.9375V68.9355H247.477V67.9375H251.272Z",
    fill: "#003F8C"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M255.988 67.9375V68.9355H252.193V67.9375H255.988Z",
    fill: "#003F8C"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M263.965 67.9375V68.9355H260.17V67.9375H263.965Z",
    fill: "#003F8C"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M268.68 67.9375V68.9355H264.885V67.9375H268.68Z",
    fill: "#003F8C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M273.397 67.9375V68.9355H269.602V67.9375H273.397Z",
    fill: "#003F8C"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M281.373 67.9375V68.9355H277.578V67.9375H281.373Z",
    fill: "#003F8C"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M289.346 67.9375V68.9355H285.551V67.9375H289.346Z",
    fill: "#003F8C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M352.586 232.285L341.887 273.569L352.009 276.536L352.586 232.285Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M357.389 188.663C357.389 188.663 355.612 186.452 356.163 182.381C356.715 178.31 361.625 177.381 361.625 177.381C361.625 177.381 362.692 176.569 366.636 178.06C370.58 179.551 400.956 183.669 420.372 186.301C439.788 188.933 446.078 187.234 445.812 193.896C445.546 200.558 428.5 260.435 428.246 262.314C427.991 264.193 357.389 188.663 357.389 188.663Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M439.068 199.714L357.381 188.643L344.183 286.017L425.87 297.089L439.068 199.714Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M423.889 219.165L428.644 219.809",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M394.139 215.132L420.132 218.655",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M362.643 210.862L390.38 214.622",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M416.451 226.971L427.469 228.465",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M361.469 219.518L405.178 225.443",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M383.648 231.34L426.296 237.121",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M360.295 228.174L379.264 230.745",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M397.82 242.076L425.123 245.777",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M374.646 238.934L394.688 241.651",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M359.121 236.83L371.201 238.467",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M414.186 253.108L423.951 254.432",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M357.949 245.486L407.608 252.217",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M395.16 259.345L422.776 263.089",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M356.775 254.142L390.463 258.708",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M403.695 269.316L421.602 271.744",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M367.369 264.392L399.311 268.723",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M355.602 262.797L363.611 263.883",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M439.078 199.736C439.078 199.736 440.482 186.156 445.482 191.618",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M411.378 304.353L411.296 312.977L406.263 305.874L386.074 237.965L391.188 236.444L411.378 304.353Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M390.024 236.757L387.234 237.586L407.426 305.493L410.215 304.663L390.024 236.757Z",
    fill: "#009A2E",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M411.377 304.369L406.271 305.887L411.295 312.977L411.377 304.369Z",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M408.785 309.433L411.297 312.978L411.338 308.674L408.785 309.433Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M386.371 229.602C384.959 230.022 384.154 231.507 384.574 232.92L386.074 237.966L391.189 236.445L389.689 231.399C389.268 229.987 387.783 229.182 386.371 229.602Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M386.371 229.602C384.959 230.022 384.154 231.507 384.574 232.92L385.292 235.334L390.407 233.813L389.689 231.399C389.268 229.987 387.783 229.182 386.371 229.602Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M134.55 189.488C133.912 190.39 133.275 191.334 132.646 192.316",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M145.009 177.453C145.009 177.453 141.473 180.581 137.301 185.823",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M133.661 182.755C133.661 182.755 128.631 189.844 126.246 194.797",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M204.193 204.747C203.556 205.649 202.918 206.593 202.289 207.575",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M214.651 192.712C214.651 192.712 211.115 195.84 206.943 201.082",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M203.304 198.014C203.304 198.014 198.274 205.103 195.889 210.056",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M304.008 180.013C303.096 179.39 302.142 178.767 301.15 178.153",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M316.206 190.284C316.206 190.284 313.023 186.798 307.717 182.707",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M310.726 179.02C310.726 179.02 303.559 174.101 298.57 171.793",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M201.145 241.992C200.632 245.753 199.848 250.962 199.064 254.097",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M201.731 237.432C201.731 237.432 201.648 238.141 201.502 239.288",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M204.398 248.099C204.398 248.099 202.398 254.766 200.398 258.766",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M254.398 253.432C254.398 253.432 255.065 262.099 259.731 266.765",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M253.732 262.099C253.732 262.099 255.732 268.099 259.732 270.766",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M117.861 308.44C117.861 308.44 122.3 304.869 122.3 274.184C122.3 243.499 127.414 221.074 133.709 211.239C140.003 201.404 145.905 197.47 148.658 197.47C151.411 197.47 149.445 201.011 145.511 206.125C141.577 211.239 138.036 213.993 136.463 220.288C134.889 226.582 134.889 234.451 136.856 233.664C138.823 232.877 141.97 217.141 144.724 211.24C147.478 205.339 154.166 197.864 158.1 194.324C162.034 190.783 170.689 180.161 174.623 182.915C178.557 185.669 176.197 189.603 173.836 191.177C171.476 192.751 162.034 202.192 157.706 208.094C153.379 213.995 150.625 228.945 152.985 229.338C155.345 229.731 162.427 207.701 166.361 202.98C170.295 198.259 186.031 185.277 189.572 184.883C193.113 184.49 193.506 189.997 190.359 192.751C187.212 195.505 176.59 207.307 173.049 214.388C169.508 221.469 167.935 234.452 171.082 231.305C174.229 228.158 179.344 215.175 183.671 210.848C187.998 206.521 200.981 192.751 204.128 194.325C207.275 195.899 206.489 199.833 203.735 202.586C200.981 205.34 190.359 220.289 187.605 228.157C184.851 236.025 181.704 258.056 183.278 254.909C184.852 251.762 189.966 235.632 192.72 228.944C195.474 222.256 200.982 219.109 201.768 222.256C202.555 225.403 200.981 226.977 199.014 234.058C197.047 241.139 197.047 260.023 191.146 270.645C185.245 281.267 161.772 303.859 158.625 311.727C155.478 319.595 150.514 327.326 150.514 327.326",
    fill: "#003F8C"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M336.45 311.101C336.45 311.101 331.887 304.869 331.887 274.184C331.887 243.499 326.773 221.074 320.478 211.239C314.184 201.404 308.282 197.47 305.529 197.47C302.775 197.47 304.742 201.011 308.676 206.125C312.61 211.239 316.151 213.993 317.724 220.288C319.298 226.582 319.298 234.451 317.331 233.664C315.364 232.877 312.217 217.141 309.463 211.24C306.709 205.339 300.021 197.864 296.087 194.324C292.153 190.783 283.498 180.161 279.564 182.915C275.63 185.669 277.99 189.603 280.351 191.177C282.711 192.751 292.153 202.192 296.481 208.094C300.809 213.995 303.562 228.945 301.202 229.338C298.842 229.731 291.76 207.701 287.826 202.98C283.892 198.259 268.156 185.277 264.615 184.883C261.074 184.49 260.681 189.997 263.828 192.751C266.975 195.505 277.597 207.307 281.138 214.388C284.679 221.469 286.252 234.452 283.105 231.305C279.958 228.158 274.843 215.175 270.516 210.848C266.188 206.521 253.206 192.751 250.059 194.325C246.912 195.899 247.699 199.833 250.452 202.586C253.206 205.34 263.828 220.289 266.582 228.157C269.336 236.025 272.483 258.056 270.909 254.909C269.335 251.762 264.221 235.632 261.467 228.944C258.713 222.256 253.205 219.109 252.419 222.256C251.632 225.403 253.206 226.977 255.173 234.058C257.14 241.139 257.14 260.023 263.041 270.645C268.942 281.267 291.76 301.874 294.907 309.742C298.054 317.61 303.798 329.986 303.798 329.986",
    fill: "#003F8C"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M116.398 316.034C116.398 316.034 122.299 296.757 122.299 266.071C122.299 235.385 127.413 212.961 133.708 203.126C140.002 193.291 145.904 189.357 148.657 189.357C151.41 189.357 149.444 192.898 145.51 198.012C141.576 203.126 138.035 205.88 136.462 212.175C134.888 218.469 134.888 226.338 136.855 225.551C138.822 224.764 141.969 209.028 144.723 203.127C147.477 197.226 154.165 189.751 158.099 186.211C162.033 182.67 170.688 172.048 174.622 174.802C178.556 177.556 176.196 181.49 173.835 183.063C171.475 184.637 162.033 194.078 157.705 199.98C153.378 205.881 150.624 220.83 152.984 221.224C155.344 221.617 162.426 199.587 166.36 194.866C170.294 190.145 186.03 177.163 189.571 176.769C193.112 176.376 193.505 181.883 190.358 184.637C187.211 187.391 176.589 199.193 173.048 206.274C169.507 213.355 167.934 226.338 171.081 223.191C174.228 220.044 179.343 207.061 183.67 202.734C187.997 198.407 200.98 184.637 204.127 186.211C207.274 187.785 206.488 191.719 203.734 194.473C200.98 197.227 190.358 212.176 187.604 220.044C184.85 227.912 181.703 249.943 183.277 246.796C184.851 243.649 189.965 227.519 192.719 220.831C195.473 214.143 200.981 210.996 201.767 214.143C202.554 217.29 200.98 218.864 199.013 225.945C197.046 233.026 197.046 251.91 191.145 262.532C185.244 273.154 162.426 301.873 159.279 309.741C156.132 317.609 149.05 334.919 149.05 334.919",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M116.398 316.034C116.398 316.034 122.299 296.757 122.299 266.071C122.299 235.385 127.413 212.961 133.708 203.126C140.002 193.291 145.904 189.357 148.657 189.357C151.41 189.357 149.444 192.898 145.51 198.012C141.576 203.126 138.035 205.88 136.462 212.175C134.888 218.469 134.888 226.338 136.855 225.551C138.822 224.764 141.969 209.028 144.723 203.127C147.477 197.226 154.165 189.751 158.099 186.211C162.033 182.67 170.688 172.048 174.622 174.802C178.556 177.556 176.196 181.49 173.835 183.063C171.475 184.637 162.033 194.078 157.705 199.98C153.378 205.881 150.624 220.83 152.984 221.224C155.344 221.617 162.426 199.587 166.36 194.866C170.294 190.145 186.03 177.163 189.571 176.769C193.112 176.376 193.505 181.883 190.358 184.637C187.211 187.391 176.589 199.193 173.048 206.274C169.507 213.355 167.934 226.338 171.081 223.191C174.228 220.044 179.343 207.061 183.67 202.734C187.997 198.407 200.98 184.637 204.127 186.211C207.274 187.785 206.488 191.719 203.734 194.473C200.98 197.227 190.358 212.176 187.604 220.044C184.85 227.912 181.703 249.943 183.277 246.796C184.851 243.649 189.965 227.519 192.719 220.831C195.473 214.143 200.981 210.996 201.767 214.143C202.554 217.29 200.98 218.864 199.013 225.945C197.046 233.026 197.046 251.91 191.145 262.532C185.244 273.154 162.426 301.873 159.279 309.741C156.132 317.609 149.05 334.919 149.05 334.919",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M337.788 316.034C337.788 316.034 331.887 296.757 331.887 266.071C331.887 235.385 326.773 212.961 320.478 203.126C314.184 193.291 308.282 189.357 305.529 189.357C302.775 189.357 304.742 192.898 308.676 198.012C312.61 203.126 316.151 205.88 317.724 212.175C319.298 218.469 319.298 226.338 317.331 225.551C315.364 224.764 312.217 209.028 309.463 203.127C306.709 197.226 300.021 189.751 296.087 186.211C292.153 182.67 283.498 172.048 279.564 174.802C275.63 177.556 277.99 181.49 280.351 183.063C282.711 184.637 292.153 194.078 296.481 199.98C300.809 205.881 303.562 220.83 301.202 221.224C298.842 221.617 291.76 199.587 287.826 194.866C283.892 190.145 268.156 177.163 264.615 176.769C261.074 176.376 260.681 181.883 263.828 184.637C266.975 187.391 277.597 199.193 281.138 206.274C284.679 213.355 286.252 226.338 283.105 223.191C279.958 220.044 274.843 207.061 270.516 202.734C266.188 198.407 253.206 184.637 250.059 186.211C246.912 187.785 247.699 191.719 250.452 194.473C253.206 197.227 263.828 212.176 266.582 220.044C269.336 227.912 272.483 249.943 270.909 246.796C269.335 243.649 264.221 227.519 261.467 220.831C258.713 214.143 253.205 210.996 252.419 214.143C251.632 217.29 253.206 218.864 255.173 225.945C257.14 233.026 257.14 251.91 263.041 262.532C268.942 273.154 291.76 301.873 294.907 309.741C298.054 317.609 305.136 334.919 305.136 334.919",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M337.788 316.034C337.788 316.034 331.887 296.757 331.887 266.071C331.887 235.385 326.773 212.961 320.478 203.126C314.184 193.291 308.282 189.357 305.529 189.357C302.775 189.357 304.742 192.898 308.676 198.012C312.61 203.126 316.151 205.88 317.724 212.175C319.298 218.469 319.298 226.338 317.331 225.551C315.364 224.764 312.217 209.028 309.463 203.127C306.709 197.226 300.021 189.751 296.087 186.211C292.153 182.67 283.498 172.048 279.564 174.802C275.63 177.556 277.99 181.49 280.351 183.063C282.711 184.637 292.153 194.078 296.481 199.98C300.809 205.881 303.562 220.83 301.202 221.224C298.842 221.617 291.76 199.587 287.826 194.866C283.892 190.145 268.156 177.163 264.615 176.769C261.074 176.376 260.681 181.883 263.828 184.637C266.975 187.391 277.597 199.193 281.138 206.274C284.679 213.355 286.252 226.338 283.105 223.191C279.958 220.044 274.843 207.061 270.516 202.734C266.188 198.407 253.206 184.637 250.059 186.211C246.912 187.785 247.699 191.719 250.452 194.473C253.206 197.227 263.828 212.176 266.582 220.044C269.336 227.912 272.483 249.943 270.909 246.796C269.335 243.649 264.221 227.519 261.467 220.831C258.713 214.143 253.205 210.996 252.419 214.143C251.632 217.29 253.206 218.864 255.173 225.945C257.14 233.026 257.14 251.91 263.041 262.532C268.942 273.154 291.76 301.873 294.907 309.741C298.054 317.609 305.136 334.919 305.136 334.919",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4961 376H151.446C152.231 373.004 153.205 369.645 154.421 365.997C159.135 351.855 174.455 334.178 174.455 334.178C174.455 334.178 159.724 320.036 136.744 312.965C113.764 305.895 96.9001 308 96.9001 308C96.9001 308 102.071 326.448 97.9001 347C94.9451 361.564 92.8861 370.774 91.4961 376Z",
    fill: "#009A2E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M302.297 376.001H364.642C362.649 370.819 358.324 359.574 353.996 348.321C348.104 333.001 350.461 312.377 348.104 312.377C345.747 312.377 319.231 310.609 306.268 314.734C293.305 318.859 278.574 330.643 278.574 330.643C278.574 330.643 288.591 341.839 295.662 355.98C298.837 362.335 300.941 369.753 302.297 376.001Z",
    fill: "#009A2E",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M128.976 320.203C128.55 318.498 122.154 321.056 122.154 321.056C122.154 321.056 124.286 312.955 120.875 312.955C117.464 312.955 117.038 318.924 117.038 318.924C117.038 318.924 110.643 316.366 110.643 320.203C110.643 324.04 114.907 324.04 114.907 324.04C114.907 324.04 109.791 330.435 113.628 331.714C117.465 332.993 120.023 328.303 120.023 328.303C120.023 328.303 122.581 332.566 125.992 330.861C129.403 329.155 126.845 325.318 126.845 325.318C126.845 325.318 129.402 321.909 128.976 320.203ZM120.449 326.598C119.272 326.598 118.317 325.834 118.317 324.893C118.317 323.951 119.271 323.188 120.449 323.188C121.626 323.188 122.581 323.952 122.581 324.893C122.58 325.835 121.626 326.598 120.449 326.598ZM138.355 367.954C137.929 366.249 131.533 368.807 131.533 368.807C131.533 368.807 133.665 360.706 130.254 360.706C126.843 360.706 126.417 366.675 126.417 366.675C126.417 366.675 120.022 364.117 120.022 367.954C120.022 371.791 124.286 371.791 124.286 371.791C124.286 371.791 119.17 378.186 123.007 379.465C126.844 380.744 129.402 376.054 129.402 376.054C129.402 376.054 131.96 380.317 135.371 378.612C138.782 376.906 136.224 373.069 136.224 373.069C136.224 373.069 138.782 369.66 138.355 367.954ZM129.828 374.349C128.651 374.349 127.696 373.585 127.696 372.644C127.696 371.702 128.65 370.939 129.828 370.939C131.005 370.939 131.96 371.702 131.96 372.644C131.96 373.586 131.006 374.349 129.828 374.349ZM100.837 374.349C100.411 372.644 94.0149 375.202 94.0149 375.202C94.0149 375.202 96.1469 367.101 92.7359 367.101C89.3249 367.101 88.8989 373.07 88.8989 373.07C88.8989 373.07 82.5039 370.512 82.5039 374.349C82.5039 378.186 86.7669 378.186 86.7669 378.186C86.7669 378.186 81.6509 384.581 85.4879 385.86C89.3249 387.139 91.8829 382.449 91.8829 382.449C91.8829 382.449 94.4409 386.712 97.8519 385.007C101.263 383.302 98.7049 379.465 98.7049 379.465C98.7049 379.465 101.263 376.055 100.837 374.349ZM92.3099 380.745C91.1329 380.745 90.1779 379.982 90.1779 379.04C90.1779 378.098 91.1319 377.335 92.3099 377.335C93.4869 377.335 94.4419 378.098 94.4419 379.04C94.4409 379.981 93.4869 380.745 92.3099 380.745ZM147.309 341.094C147.309 341.094 148.588 341.094 151.999 341.094C155.41 341.094 157.542 344.931 157.542 344.931C150.293 347.063 147.309 341.094 147.309 341.094ZM142.619 374.349C142.619 374.349 143.898 374.349 147.309 374.349C150.72 374.349 152.852 378.186 152.852 378.186C145.603 380.318 142.619 374.349 142.619 374.349ZM101.689 367.954C101.689 367.954 102.968 367.954 106.379 367.954C109.79 367.954 111.922 371.791 111.922 371.791C104.674 373.923 101.689 367.954 101.689 367.954ZM124.365 337.862C124.365 337.862 125.11 338.902 127.098 341.673C129.085 344.445 127.209 348.413 127.209 348.413C121.253 343.765 124.365 337.862 124.365 337.862ZM100.848 350.645C100.848 350.645 101.433 349.508 102.995 346.475C104.556 343.442 108.944 343.304 108.944 343.304C107.521 350.724 100.848 350.645 100.848 350.645Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M329.787 328.305C329.361 326.6 322.965 329.158 322.965 329.158C322.965 329.158 325.097 321.057 321.686 321.057C318.275 321.057 317.849 327.026 317.849 327.026C317.849 327.026 311.454 324.468 311.454 328.305C311.454 332.142 315.717 332.142 315.717 332.142C315.717 332.142 310.601 338.537 314.438 339.816C318.275 341.095 320.833 336.405 320.833 336.405C320.833 336.405 323.391 340.669 326.802 338.963C330.213 337.257 327.655 333.42 327.655 333.42C327.655 333.42 330.213 330.01 329.787 328.305ZM321.26 334.7C320.083 334.7 319.128 333.936 319.128 332.995C319.128 332.053 320.082 331.29 321.26 331.29C322.437 331.29 323.392 332.053 323.392 332.995C323.391 333.936 322.437 334.7 321.26 334.7ZM349.825 361.56C349.399 359.855 343.003 362.413 343.003 362.413C343.003 362.413 345.135 354.312 341.724 354.312C338.313 354.312 337.887 360.281 337.887 360.281C337.887 360.281 331.492 357.723 331.492 361.56C331.492 365.397 335.755 365.397 335.755 365.397C335.755 365.397 330.639 371.792 334.476 373.071C338.313 374.35 340.871 369.66 340.871 369.66C340.871 369.66 343.429 373.924 346.84 372.218C350.251 370.513 347.693 366.676 347.693 366.676C347.693 366.676 350.251 363.265 349.825 361.56ZM341.298 367.955C340.121 367.955 339.166 367.191 339.166 366.25C339.166 365.308 340.12 364.544 341.298 364.544C342.475 364.544 343.43 365.308 343.43 366.25C343.43 367.192 342.475 367.955 341.298 367.955ZM328.508 374.35C328.082 372.645 321.686 375.203 321.686 375.203C321.686 375.203 323.818 367.102 320.407 367.102C316.996 367.102 316.57 373.071 316.57 373.071C316.57 373.071 310.175 370.513 310.175 374.35C310.175 378.187 314.439 378.187 314.439 378.187C314.439 378.187 309.323 384.582 313.16 385.861C316.997 387.14 319.555 382.45 319.555 382.45C319.555 382.45 322.113 386.713 325.524 385.008C328.935 383.303 326.377 379.465 326.377 379.465C326.377 379.465 328.934 376.056 328.508 374.35ZM319.981 380.746C318.804 380.746 317.849 379.983 317.849 379.041C317.849 378.099 318.803 377.336 319.981 377.336C321.158 377.336 322.113 378.099 322.113 379.041C322.112 379.982 321.158 380.746 319.981 380.746ZM348.12 349.196C348.12 349.196 349.399 349.196 352.81 349.196C356.221 349.196 358.352 353.033 358.352 353.033C351.104 355.165 348.12 349.196 348.12 349.196ZM297.811 373.498C297.811 373.498 299.09 373.498 302.501 373.498C305.912 373.498 308.044 377.335 308.044 377.335C300.795 379.467 297.811 373.498 297.811 373.498ZM325.176 345.963C325.176 345.963 325.921 347.002 327.909 349.774C329.896 352.546 328.02 356.514 328.02 356.514C322.064 351.867 325.176 345.963 325.176 345.963ZM352.889 369.839C352.889 369.839 353.634 370.878 355.622 373.65C357.609 376.422 355.733 380.39 355.733 380.39C349.777 375.742 352.889 369.839 352.889 369.839ZM301.659 358.747C301.659 358.747 302.245 357.61 303.806 354.577C305.367 351.544 309.755 351.406 309.755 351.406C308.332 358.826 301.659 358.747 301.659 358.747Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyping);
export default __webpack_public_path__ + "static/media/Typing.e69ec376bffab51fd7c4c9d4e2fa771e.svg";
export { ForwardRef as ReactComponent };